// @flow

export const DEFAULT_TITLE = 'Create a new staff member';
